import './styles.scss';
import img1 from 'assets/image-from-rawpixel-id-2858870.png';

const CovidHeroSection = () => {
    return (
        <div className='__CovidHeroSection'>
            <img alt='' src={img1} className='d-block w-100' />
        </div>
    )
}

export default CovidHeroSection;